import { useMemo } from 'react';
import { NOT_LOGGED_IN_USER_ID } from "../constants";
import { cleanToken, isTokenValid } from "../internals";
import { tokenContext } from "./tokenContext";
import { jsx as _jsx } from "react/jsx-runtime";
export const PrefetchedTokenProvider = ({
  token: initialToken,
  customerId,
  children
}) => {
  const token = initialToken ? cleanToken(initialToken) : undefined;
  if (!token || !isTokenValid(token)) {
    throw new Error('Received an invalid token. It is either malformed or expired');
  }
  const contextValue = useMemo(() => ({
    token,
    formattedToken: `Bearer ${token}`,
    customerId,
    isAnonymousUser: customerId === NOT_LOGGED_IN_USER_ID
  }), [customerId, token]);
  return /*#__PURE__*/_jsx(tokenContext.Provider, {
    value: contextValue,
    children: children
  });
};
//# sourceMappingURL=PrefetchedTokenProvider.js.map